import {
  Invoice,
  InvoiceStatus,
  PayoutDestinationSummaryType,
  TaxWithholdingSettings
} from "@wingspanhq/wingspan-api-sdk";

export const getInvoiceTaxWithholdings = (
  taxWithholdingSettings: TaxWithholdingSettings | undefined,
  invoice: Invoice,
  netIncome: number,
  hasActiveTaxWithholdingAccount: boolean
): {
  amount: number;
  rate: number;
} => {
  if (invoice.status === InvoiceStatus.PAID) {
    const amountWithheld = (invoice.payouts || [])
      .filter(
        payout =>
          payout.destination?.type ===
          PayoutDestinationSummaryType.TAX_WITHHOLDING
      )
      .reduce((total, payout) => total + payout.amount, 0);

    return {
      amount: amountWithheld,
      rate:
        invoice.taxWithholdingRate ??
        taxWithholdingSettings?.withholdingRate ??
        0
    };
  }

  const isActive =
    hasActiveTaxWithholdingAccount &&
    taxWithholdingSettings?.isEnabled === true;

  const defaultRate = isActive
    ? taxWithholdingSettings?.withholdingRate || 0
    : 0;

  return {
    amount: netIncome * (defaultRate / 100),
    rate: defaultRate
  };
};
